module.exports = __webpack_public_path__ + "static/media/sandeep.f788cf7e.jpg";